import React, { useState, useEffect } from 'react';
import { getUsers, addUser, updateUser, deleteUser } from '../utils/api';

const ROLES = { 1: 'Admin', 2: 'Operator', 3: 'Viewer' };

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ newAccount:'', newPassword:'', privilege:2, expireTime:'2099-12-31', remark:'' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const load = () => {
    setLoading(true);
    getUsers().then(d => setUsers(d.users || [])).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const openAdd = () => { setForm({ newAccount:'', newPassword:'', privilege:2, expireTime:'2099-12-31', remark:'' }); setModal('add'); setMsg(''); };
  const openEdit = (u) => { setForm({ newAccount:u.account, newPassword:'', privilege:u.privilege||2, expireTime:u.expireTime||'2099-12-31', remark:u.remark||'', targetAccount:u.account }); setModal('edit'); setMsg(''); };

  const save = async () => {
    setSaving(true); setMsg('');
    try {
      const res = modal === 'add' ? await addUser(form) : await updateUser({ ...form });
      if (res.success) { setModal(null); load(); } else setMsg(res.msg || 'Failed');
    } catch (e) { setMsg('Server error'); }
    setSaving(false);
  };

  const del = async (account) => {
    if (!window.confirm(`Delete user "${account}"?`)) return;
    await deleteUser(account);
    load();
  };

  const F = ({ label, children }) => (
    <div style={{ marginBottom:12 }}>
      <div style={{ fontSize:11, color:'#888', marginBottom:4, fontWeight:500 }}>{label}</div>
      {children}
    </div>
  );
  const inp = (key, type='text', placeholder='') => (
    <input type={type} value={form[key]} placeholder={placeholder} onChange={e => setForm(f => ({...f,[key]:e.target.value}))}
      style={{ width:'100%', padding:'7px 9px', fontSize:12, border:'0.5px solid #ddd', borderRadius:6 }} />
  );

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
        <div style={{ fontSize:13, color:'#666' }}>Manage CMSV6 sub-accounts</div>
        <button onClick={openAdd} style={{ padding:'7px 16px', background:'#185FA5', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer', fontWeight:500 }}>+ Add user</button>
      </div>

      <div style={{ background:'white', border:'0.5px solid #e8e8e8', borderRadius:12, overflow:'hidden' }}>
        {loading ? <div style={{ padding:20, fontSize:12, color:'#aaa' }}>Loading users from CMSV6...</div> : (
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
            <thead>
              <tr style={{ background:'#fafafa' }}>
                {['Username','Role','Expire','Remark','Actions'].map(h => (
                  <th key={h} style={{ textAlign:'left', padding:'9px 12px', fontSize:11, color:'#999', borderBottom:'0.5px solid #eee', fontWeight:500 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {users.length === 0 && (
                <tr><td colSpan={5} style={{ padding:'20px 12px', textAlign:'center', color:'#aaa', fontSize:12 }}>No sub-users found. Add one above.</td></tr>
              )}
              {users.map((u, i) => (
                <tr key={i} style={{ borderBottom:'0.5px solid #f5f5f5' }}>
                  <td style={{ padding:'9px 12px', fontWeight:500 }}>{u.account}</td>
                  <td style={{ padding:'9px 12px' }}>
                    <span style={{ background: u.privilege===1?'#FCEBEB':u.privilege===2?'#E6F1FB':'#EAF3DE', color: u.privilege===1?'#A32D2D':u.privilege===2?'#0C447C':'#3B6D11', fontSize:10, padding:'2px 7px', borderRadius:8, fontWeight:500 }}>
                      {ROLES[u.privilege] || 'User'}
                    </span>
                  </td>
                  <td style={{ padding:'9px 12px', color:'#888' }}>{u.expireTime || '—'}</td>
                  <td style={{ padding:'9px 12px', color:'#aaa' }}>{u.remark || '—'}</td>
                  <td style={{ padding:'9px 12px' }}>
                    <button onClick={() => openEdit(u)} style={{ padding:'3px 9px', fontSize:11, border:'0.5px solid #ddd', borderRadius:5, background:'white', cursor:'pointer', marginRight:4 }}>Edit</button>
                    <button onClick={() => del(u.account)} style={{ padding:'3px 9px', fontSize:11, border:'0.5px solid #f5b7b7', borderRadius:5, background:'white', color:'#c0392b', cursor:'pointer' }}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal */}
      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div style={{ background:'white', borderRadius:12, padding:24, width:360, border:'0.5px solid #e0e0e0' }}>
            <div style={{ fontSize:14, fontWeight:500, marginBottom:16 }}>{modal === 'add' ? 'Add new user' : `Edit: ${form.targetAccount}`}</div>
            {modal === 'add' && <F label="Username">{inp('newAccount','text','e.g. driver_john')}</F>}
            <F label={modal === 'edit' ? 'New password (leave blank to keep)' : 'Password'}>{inp('newPassword','password','Password')}</F>
            <F label="Role">
              <select value={form.privilege} onChange={e => setForm(f => ({...f, privilege:Number(e.target.value)}))}
                style={{ width:'100%', padding:'7px 9px', fontSize:12, border:'0.5px solid #ddd', borderRadius:6 }}>
                <option value={1}>Admin</option>
                <option value={2}>Operator</option>
                <option value={3}>Viewer</option>
              </select>
            </F>
            <F label="Expire date">{inp('expireTime','date')}</F>
            <F label="Remark">{inp('remark','text','Optional note')}</F>
            {msg && <div style={{ fontSize:11, color:'#c0392b', background:'#fdecea', padding:'6px 10px', borderRadius:5, marginBottom:10 }}>{msg}</div>}
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
              <button onClick={() => setModal(null)} style={{ padding:'7px 14px', fontSize:12, border:'0.5px solid #ddd', borderRadius:6, background:'white', cursor:'pointer' }}>Cancel</button>
              <button onClick={save} disabled={saving} style={{ padding:'7px 14px', fontSize:12, background: saving?'#aaa':'#185FA5', color:'white', border:'none', borderRadius:6, cursor:'pointer', fontWeight:500 }}>
                {saving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
